import type { FC } from 'react';
import type { VectorName } from '@/ui/components/VectorGraphic/VectorGraphic';
import Link from '@/ui/components/Link/Link';
import VectorGraphic from '@/ui/components/VectorGraphic/VectorGraphic';
import { useGA4 } from '@/ui/context/ga4';

import $ from './SocialLinks.module.scss';

export type SocialLinksProps = {
  /** Title for the social links block (e.g. for screen readers). */
  title?: string;
  /** Social link items from Uniform composition. Renders nothing when empty or undefined. */
  items?: Array<{
    id: string;
    icon: string;
    url: string;
    ariaLabel?: string;
  }>;
};

const SocialLinks: FC<SocialLinksProps> = ({ title, items = [] }) => {
  const { trackMenuNavigation } = useGA4();

  return (
    <div className={$.socialLinks}>
      {title && <span className={$.visuallyHidden}>{title}</span>}
      <ul className={$.socialList}>
        {items.map(({ id, icon, url, ariaLabel }) => (
          <li key={id} className={$.socialItem}>
            <Link
              href={url}
              isExternal
              ariaLabel={ariaLabel ?? id}
              onClick={() =>
                trackMenuNavigation({
                  menu: 'footer',
                  menu_path: url,
                  menu_text: ariaLabel ?? id,
                  menu_click: 'picture',
                })
              }
            >
              <VectorGraphic name={icon as VectorName} />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SocialLinks;
